import { render, staticRenderFns } from "./NotificationSnoozeCard.vue?vue&type=template&id=07786fea&scoped=true"
import script from "./NotificationSnoozeCard.vue?vue&type=script&lang=js"
export * from "./NotificationSnoozeCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationSnoozeCard.vue?vue&type=style&index=0&id=07786fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07786fea",
  null
  
)

export default component.exports